import { Grid, Typography, Link } from '@mui/material';
import { useState } from 'react';
import NoticeDialogContract from 'src/components/NoticeDialogContract';
import mandants from 'src/config/mandant';
import { useAppSelector } from 'src/utils/hooks';

export default function CorrectInformationOnly() {
  const [open, setOpen] = useState(false);
  const { mandant, isColorBlindMode } = useAppSelector((state) => state.config);

  type MandantKey = keyof typeof mandants;
  const { dataprotectionC } = mandants[mandant as MandantKey]?.footer;
  const { dataprotText } = mandants[mandant as MandantKey]?.footer;
  return (
    <>
      <NoticeDialogContract open={open} setOpen={setOpen} />
      <Grid
        sx={{
          ...(isColorBlindMode && {
            backgroundColor: '#FFF',
            color: 'black',
          }),
        }}
      >
        {isColorBlindMode ? (
          <Typography
            variant="body1"
            sx={{
               maxWidth: '1030px',
              fontFamily: 'Helvetica Neue',
              fontWeight: 700,
              fontStyle: 'normal', 
              fontSize: '14px',
              lineHeight: '100%',
              letterSpacing: '0',
            }}
          >
            Ich bestätige, dass ich die{' '}
            <Link
              href={dataprotectionC}
              target="_blank"
              underline="hover"
              sx={{
                fontFamily: 'Helvetica Neue',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '14px',
                lineHeight: '1.2',
                letterSpacing: '0',
              }}
            >
              {dataprotText}
            </Link>{' '}
            gelesen habe. Und dass ich damit einverstanden bin. Ich bestätige
            auch, dass ich bei einem Träger der gesetzlichen Krankenversicherung
            versichert bin. Oder dass ich dort einen Anspruch auf
            Familienversicherung oder auf freie
            Heilfürsorge habe.
          </Typography>
        ) : (
          <Typography variant="body1">
            Ich bestätige, die{' '}
            <Link href={dataprotectionC} target="_blank" underline="hover">
              {dataprotText}
            </Link>{' '}
            gelesen zu haben und erkläre mich damit einverstanden und bestätige,
            dass ich bei einem Träger der gesetzlichen Krankenversicherung (GKV)
            versichert bin bzw. dort ein Anspruch auf Familienversicherung
            besteht oder Anspruch auf freie Heilfürsorge besteht.
          </Typography>
        )}
      </Grid>
    </>
  );
}
